module.exports = __webpack_public_path__ + "static/media/edit.6010d7e7.svg";